import * as React from 'react';
import { DeluxeContext } from '.';
import styles from './Deluxe.css';
import {
  Features,
  Feature,
  Payment,
  Thanks,
  Terms,
} from './pages';

export const DeluxeMain = () => {
  return (
    <DeluxeContext.Consumer>
      {({ currentSelection }) => {
        const { page } = currentSelection;
        return (    
          <main>
            <section>
              <div className={styles['main-container']}>
                {page === 'features' && <Features />}
                {page === 'feature' && <Feature />}
                {page === 'payment' && <Payment />}
                {page === 'thanks' && <Thanks />}
                {page === 'terms' && <Terms />}
              </div>
            </section>
          </main> 
        );
      }}
    </DeluxeContext.Consumer>    
  );
};